import { useState } from "react";
import { WrappedFieldProps } from "redux-form";

import FormError from "../styled/FormError";
import FormGroup from "../styled/FormGroup";
import FormLabel from "../styled/FormLabel";
import {
  FormMeta,
  FormInput,
  inputAutofillAnimationCancel,
  inputAutofillAnimationStart,
} from "../styled";

interface Props extends WrappedFieldProps {
  autoComplete?: string;
  disabled?: boolean;
  disabledDarker?: boolean;
  errorOnSingleLine?: boolean;
  fieldNotTouched?: boolean;
  isHidden?: boolean;
  isLoading?: boolean;
  label?: string;
  margin?: string;
  maxLength?: number;
  metaInfo?: string;
  name?: string;
  opacity?: boolean;
  placeholder?: string;
  raisedLabel?: boolean;
  readOnly?: boolean;
  shouldShowError?: boolean;
  showErrorBeforeSubmit?: boolean;
  showSeconds?: boolean;
  time?: string;
  type?: string;
  width?: string;
  withEllipsesText?: boolean;
  size?:
    | "xxSmall"
    | "xSmall"
    | "small"
    | "medium"
    | "large"
    | "xLarge"
    | "xxLarge"
    | "xxxLarge";
  noBottomBorder?: boolean;
}

const Input = ({
  autoComplete,
  disabled,
  disabledDarker,
  errorOnSingleLine,
  fieldNotTouched,
  input,
  isHidden,
  isLoading,
  label,
  margin,
  maxLength,
  meta: { asyncValidating, submitFailed, error },
  metaInfo,
  name,
  opacity,
  placeholder,
  raisedLabel,
  readOnly,
  shouldShowError,
  showErrorBeforeSubmit,
  showSeconds = true,
  time,
  type,
  width,
  size,
  ...props
}: Props) => {
  const [isAutoFilled, setIsAutoFilled] = useState(false);

  return (
    <FormGroup
      hasValue={input.value || input.value === 0 || isAutoFilled}
      isLoading={isLoading || asyncValidating}
      margin={margin}
      width={width}
      raisedLabel={raisedLabel}
      disabled={disabled}
      isHidden={isHidden}
      size={size}
    >
      {!!label && <FormLabel>{label}</FormLabel>}

      <FormInput
        {...input}
        {...props}
        readOnly={readOnly}
        disabled={disabled || disabledDarker}
        disabledDarker={disabledDarker}
        opacity={opacity}
        hasError={
          (submitFailed || showErrorBeforeSubmit) && error && !fieldNotTouched
        }
        placeholder={placeholder}
        maxLength={maxLength}
        type={type}
        onAnimationStart={(e) => {
          switch (e.animationName) {
            default:
            case (inputAutofillAnimationStart as any).name:
              setIsAutoFilled(true);
              break;

            case (inputAutofillAnimationCancel as any).name:
              setIsAutoFilled(false);
              break;
          }
        }}
        onFocus={() => setIsAutoFilled(false)}
        shouldShowError={shouldShowError}
      />

      {!!metaInfo && (
        <FormMeta singleLine={errorOnSingleLine}>{metaInfo}</FormMeta>
      )}

      {(submitFailed || showErrorBeforeSubmit) && error && !fieldNotTouched && (
        <FormError errorOnSingleLine={errorOnSingleLine}>{error}</FormError>
      )}
    </FormGroup>
  );
};

export default Input;
